const announcerElem = document.querySelector('.js-announcer');

export function Announcer(announcement, reset = false) {
    if (announcerElem) {
        announcerElem.innerHTML = announcement;

        if (reset === true) {
            setTimeout(function () {
                announcerElem.innerHTML = '';
            }, 3000);
        }
    }
}
